// extracted by mini-css-extract-plugin
export default {"navigation-block-wrapper":"RRGQM","navigation-block-wrapper--full-height":"LeSZt"};